/** Máscaras de entrada. O backend aceita (e normaliza) valores com ou sem máscara. */

export const digits = (v: string | null | undefined) => (v ?? '').replace(/\D/g, '');

function apply(pattern: string, raw: string): string {
  let out = '';
  let i = 0;
  for (const ch of pattern) {
    if (i >= raw.length) break;
    if (ch === '#') out += raw[i++];
    else out += ch;
  }
  return out;
}

export const maskCpf = (v: string) => apply('###.###.###-##', digits(v).slice(0, 11));
export const maskCnpj = (v: string) => apply('##.###.###/####-##', digits(v).slice(0, 14));
export const maskCep = (v: string) => apply('#####-###', digits(v).slice(0, 8));
export const maskPhone = (v: string) => {
  const d = digits(v).slice(0, 11);
  return d.length > 10 ? apply('(##) #####-####', d) : d.length > 2 ? apply('(##) ####-####', d) : d.length ? `(${d}` : '';
};
export const maskTime = (v: string) => apply('##:##', digits(v).slice(0, 4));

export const MASKS = { cpf: maskCpf, cnpj: maskCnpj, cep: maskCep, phone: maskPhone, time: maskTime } as const;
export type MaskName = keyof typeof MASKS;
